module.exports = __webpack_public_path__ + "media/images/icons/outlined/weibo-square-adb3b2ca6f4bad825790540db2c5062a.svg";